export default "__VITE_ASSET__TK8c4H6F__"